import produce from 'immer';
import {
  ADD_COMPANY_MESSAGE,
  ADD_COMPANY_MESSAGE_SUCCESS,
  ADD_FOLDER_MESSAGE,
  ADD_FOLDER_MESSAGE_SUCCESS,
  ADD_MESSAGE,
  ADD_MESSAGE_SUCCESS,
  ADD_PARTNER_MESSAGE,
  ADD_PARTNER_MESSAGE_SUCCESS,
  DELETE_MESSAGE_SUCCESS,
  EDIT_MESSAGE_SUCCESS,
  FETCH_CHATS,
  FETCH_CHATS_SUCCESS,
  FETCH_COMPANY_CHATS,
  FETCH_COMPANY_CHATS_SUCCESS,
  FETCH_FOLDER_CHANGES,
  FETCH_FOLDER_CHANGES_SUCCESS,
  FETCH_FOLDER_CHATS,
  FETCH_FOLDER_CHATS_SUCCESS,
  FETCH_HISTORY_SUCCESS,
  FETCH_PARTNER_CHATS,
  FETCH_PARTNER_CHATS_SUCCESS,
} from 'actions/chatActions';

export const initialState = {
  list: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  submitting: false,
  createSuccess: false,
  createFailed: false,
  createError: '',
  history: [],
  folderList: [],
  partnerList: [],
  companyList: [],
  imageSuccess: [],
  folderHistory: [],
};

/* eslint-disable default-case, no-param-reassign */
const chatReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CHATS:
      case FETCH_PARTNER_CHATS:
      case FETCH_FOLDER_CHATS:
      case FETCH_COMPANY_CHATS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        if (action.clear) {
          draft.list = [];
        }
        break;

      case FETCH_CHATS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.list = action.chats;
        break;

      case ADD_MESSAGE:
      case ADD_PARTNER_MESSAGE:
      case ADD_FOLDER_MESSAGE:
      case ADD_COMPANY_MESSAGE:
        draft.submitting = true;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        break;

      case ADD_MESSAGE_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;
        if (!action.tempId) {
          draft.list.push(action.chat);
        } else {
          draft.imageSuccess.push({...action.chat, tempId: action.tempId});
        }
        draft.createError = '';

        break;

      case ADD_FOLDER_MESSAGE_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;

        if (!action.tempId) {
          draft.folderList.push(action.chat);
        } else {
          draft.imageSuccess.push({...action.chat, tempId: action.tempId});
        }
        draft.createError = '';
        break;

      case ADD_PARTNER_MESSAGE_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;

        if (!action.tempId) {
          draft.partnerList.push(action.chat);
        } else {
          draft.imageSuccess.push({...action.chat, tempId: action.tempId});
        }
        draft.createError = '';
        break;

      case ADD_COMPANY_MESSAGE_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;
        if (!action.tempId) {
          draft.companyList.push(action.chat);
        } else {
          draft.imageSuccess.push({...action.chat, tempId: action.tempId});
        }
        draft.createError = '';
        break;

      case FETCH_FOLDER_CHATS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.folderList = action.chats;
        break;

      case FETCH_PARTNER_CHATS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.partnerList = action.chats;
        break;

      case FETCH_COMPANY_CHATS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.companyList = action.chats;
        break;

      case DELETE_MESSAGE_SUCCESS:
        draft.folderList = draft.folderList.filter(
          (f) => f._id !== action.message
        );
        draft.partnerList = draft.partnerList.filter(
          (f) => f._id !== action.message
        );
        draft.companyList = draft.companyList.filter(
          (f) => f._id !== action.message
        );
        draft.list = draft.list.filter((f) => f._id !== action.message);
        break;

      case EDIT_MESSAGE_SUCCESS:
        draft.folderList = draft.folderList.map((f) =>
          f._id === action.message._id ? action.message : f
        );
        draft.partnerList = draft.partnerList.map((f) =>
          f._id === action.message._id ? action.message : f
        );
        draft.companyList = draft.companyList.map((f) =>
          f._id === action.message._id ? action.message : f
        );
        draft.list = draft.list.map((f) =>
          f._id === action.message._id ? action.message : f
        );
        break;

      case FETCH_HISTORY_SUCCESS:
        draft.history = action.history;
        break;

      case FETCH_FOLDER_CHANGES:
        draft.folderHistory = [];
        break;

      case FETCH_FOLDER_CHANGES_SUCCESS:
        draft.folderHistory = action.history;
    }
  });

export default chatReducer;
